"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRangeConfig = exports.defaultTitleConfig = exports.defaultSelectDescriptionConfig = exports.defaultSelectConfig = exports.defaultQuestionTitleConfig = exports.defaultQuestionDescriptionConfig = exports.defaultDescriptionConfig = exports.defaultButtons = exports.defaultCardConfig = exports.defaultAdvantageDescriptionConfig = exports.defaultActionButtonContainer = void 0;
var mainColor = '#4dc8c8';
var emptyMargin = {
    margin: {
        desktop: 0,
        tablet: 0,
        mobile: 0
    }
};
var defaultCardConfig = {
    backgroundColor: '#eee',
    padding: {
        desktop: '60px 40px',
        tablet: '50px 40px',
        mobile: '40px 0px 0'
    },
    nativeProps: {
        className: 'styledQuestionnaireCard'
    }
};
exports.defaultCardConfig = defaultCardConfig;
var defaultTitleConfig = {
    align: 'center'
};
exports.defaultTitleConfig = defaultTitleConfig;
var defaultDescriptionConfig = {
    align: 'center'
};
exports.defaultDescriptionConfig = defaultDescriptionConfig;
var defaultQuestionTitleConfig = __assign({ align: 'center', size: 4, padding: {
        desktop: '0 0 20px',
        tablet: '0 0 20px',
        mobile: '0 0 20px'
    } }, emptyMargin);
exports.defaultQuestionTitleConfig = defaultQuestionTitleConfig;
var defaultQuestionDescriptionConfig = {
    align: 'center'
};
exports.defaultQuestionDescriptionConfig = defaultQuestionDescriptionConfig;
var defaultSelectConfig = {
    backgroundColor: mainColor
};
exports.defaultSelectConfig = defaultSelectConfig;
var defaultSelectDescriptionConfig = {
    align: 'center'
};
exports.defaultSelectDescriptionConfig = defaultSelectDescriptionConfig;
var defaultButtons = {
    backButton: {
        backgroundColor: '#fff',
        padding: {
            desktop: '5px 10px',
            tablet: '5px 10px',
            mobile: '5px 10px'
        }
    },
    next: {
        text: 'Weiter',
        padding: {
            desktop: '16px 40px',
            tablet: '16px 40px',
            mobile: '16px 20px'
        },
        margin: {
            desktop: '10px 0',
            tablet: '10px 0',
            mobile: '0'
        }
    },
    previous: {
        text: '',
        backgroundColor: '#cfcfcd',
        padding: {
            desktop: '16px 40px',
            tablet: '16px 40px',
            mobile: '16px 20px'
        },
        margin: {
            desktop: '10px 0',
            tablet: '10px 0',
            mobile: '0'
        }
    },
    finish: {
        text: 'Jetzt Bewertung anfordern',
        padding: {
            desktop: '16px 40px',
            tablet: '16px 40px',
            mobile: '16px 20px'
        },
        margin: {
            desktop: '50px 0 0',
            tablet: '50px 0 0',
            mobile: '0'
        }
    }
};
exports.defaultButtons = defaultButtons;
var defaultAdvantageDescriptionConfig = {
    descriptionConfig: __assign({ fontSize: '13px', color: '#cfcfcd', alignItems: 'center' }, emptyMargin),
    iconConfig: {
        icon: 'done',
        color: '#cfcfcd',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};
exports.defaultAdvantageDescriptionConfig = defaultAdvantageDescriptionConfig;
var defaultRangeConfig = {
    min: 10,
    max: 50,
    default: 25,
    trackStyle: {
        height: 6,
        marginTop: 5,
        marginBottom: 5
    },
    railStyle: {
        backgroundColor: 'rgb(230, 230, 230)',
        height: 6,
        marginTop: 5,
        marginBottom: 5
    },
    handleStyle: {
        height: 24,
        width: 24,
        marginTop: -4
    },
    activeDotStyle: {
        display: 'none'
    },
    dotStyle: {
        display: 'none'
    }
};
exports.defaultRangeConfig = defaultRangeConfig;
var defaultActionButtonContainer = {
    padding: {
        desktop: '0 40px',
        tablet: '0 40px',
        mobile: '0'
    }
};
exports.defaultActionButtonContainer = defaultActionButtonContainer;
//# sourceMappingURL=Questionnaire.js.map